import api from "./core";

const basePath = "api/core/AppoinmentRequest";

export default {
  query(filter, extraHeaders = {}) {
    return api.post(`${basePath}`, filter, extraHeaders);
  },
  find(id) {
    return api.get(`${basePath}/${id}`);
  },
  getNext(id, filter) {
    return api.post(`${basePath}/GetNext/${id}`, filter);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  approve(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  update(id, input) {
    return api.put(`${basePath}/${id}`, input);
  }
};
